// @flow

import type { GridItem } from '../types';

const calculateItemPrice = (item: GridItem) => {
  return item.Price.value * (item.Cases + item.Bottles / (item.Uom || 1));
};

export { calculateItemPrice };
